export const pulse = {
  from: {
    opacity: 1,
  },
  '50%': {
    opacity: 0.5,
  },
  to: {
    opacity: 1,
  },
};

export const wave = {
  '0%': {
    backgroundPosition: '-1200px 0',
  },
  '100%': {
    backgroundPosition: '1200px 0',
  },
};
